module.exports = __webpack_public_path__ + "img/TBSRI.a26c9719.png";